// api/reminders.js
import apiClient from './client';

export const reminderApi = {
  // Get all reminders
  getAll: () => apiClient.get('/reminders'),
  
  // Get reminders by customer
  getByCustomer: (customerId) => apiClient.get(`/reminders/customer/${customerId}`),
  
  // Get high priority reminders
  getHighPriority: () => apiClient.get('/reminders/high-priority'),
  
  // Get reminders summary
  getSummary: () => apiClient.get('/reminders/summary'),
};